export default [
  'vix',
  'vix stock',
  'vix index',
  '$vix',
  'vix price',
  'volatility index',
  'vix stock price',
  'vix ticker',
  'cboe volatility index',
  'cboe vix',
  'vix index today',
  'stock vix',
  'vix volatility index',
  'vix stocks',
  'vix cboe',
  'volatility indexes',
  'vix stock',
  's&p 500 vix',
  'volitility index',
  'cboe volatility indexes',
  'vix indicator',
  'the vix index',
  'vix level',
  'vix stock price today',
  'volatility index vix',
  'cboe volatility index vix',
  'cboe volitility index',
  'market volatility index',
  'vix.stock',
  'measure of volatility',
  'volatility measures',
  'cboe index',
  'cboe vix index',
  'stock market vix',
  'vix share price',
  'vix volatility',
  'volatility s&p 500 index',
  'stock volatility index.vix',
  'vix indx',
  'vix market',
  'vix stock market',
  'how to measure volatility',
  's&p vix',
  'volitality index',
  'index vix',
  'us vix',
  'vix cboe volatility index',
  'vix level today',
  'inflation',
  'unemployment',
  'consumer price index (CPI)',
  'fed meetings',
  'interest rates',
  'gross domestic product (GDP)',
  'FOMC minutes',
  'retail sales',
  'payroll',
  'stock market',
  'elections',
  'mid-terms',
  'recession',
  'depression',
  'bankruptcy',
];
